import { gql } from '@apollo/client';

export const GET_REMAINING_TITLES = gql`
  query remainingTitles(
    $sites: [String!],
    $dateStart: DateTime,
    $dateEnd: DateTime
  ) {
    remainingTitles(
      filter: {
        sites: $sites,
        dateStart: $dateStart,
        dateEnd: $dateEnd
      }
    ) {
      ar
      tl
      nw
      siteDomain
    }
  }
`;

export const GET_WEEKLY_TITLES_GOAL = gql`
  query weeklyTitlesGoal($sites: [String!]!) {
    weeklyTitlesGoal(sites: $sites) {
      total {
        total
        article
        news
        translator
        other
      }
      bySite {
        sitePreferencesId
        domain
        article
        news
        translator
        other
      }
    }
  }
`;

export const UPDATE_WEEKLY_TITLES_GOAL = gql`
  mutation updateSitePrefs($sitePreferencesId: String!, $news: Float!, $articles: Float!, $translator: Float!) {
    sitePreferenceUpdateWeeklyFrequences(id: $sitePreferencesId, input:{
      weeklyFrequenceNews: $news
      weeklyFrequenceArticle: $articles
      weeklyFrequenceTranslator: $translator
    }) {
      weeklyFrequenceArticle
      weeklyFrequenceNews
      weeklyFrequenceTranslator
    }
  }
`;
